import ax from './customAxios';

const administradorProvider = {
  obtenerEmpresas: async () => {
    return await ax.get('/administracion/ObtenerEmpresas');
  },
  eliminarImagenPerfil: async (id) => {
    return await ax.delete(`/Adjunto/EliminarImagenPerfil/${id}`);
  },
  notificarCorreos: async (body) => {
    return await ax.post(`/administracion/EnviarCorreo`, body);
  },
  obtenerAdjunto: async (id) => {
    return await ax.get('/adjunto/ObtenerAdjunto/' + id);
  },
  obtenerAdjuntoModel: async (id) => {
    return await ax.get('/adjunto/ObtenerAdjuntoModel/' + id);
  },
  obtenerBitacora: async (id, filtros) => {
    return await ax.post('/administracion/ObtenerBitacora/' + id, filtros);
  },
  guardarAdjunto: async (e, adjuntos) => {
    const formData = new FormData();
    formData.append('entidadId', e.id);
    formData.append('codigo', e.codigo);
    formData.append('fileName', 'GESSOMA');
    adjuntos.forEach((file) => {
      formData.append('formFile', file);
    });
    return await ax.post('/adjunto/GuardarAdjuntos', formData);
  }
};
export default administradorProvider;
